function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.077 3.86v8.596a6.452 6.452 0 012.692-.57c.978 0 1.901.205 2.693.57V3.86c-.717-.43-1.653-.7-2.693-.7s-1.976.27-2.692.7zm6.461 0v8.596a6.452 6.452 0 012.693-.57c.977 0 1.9.205 2.692.57V3.86c-.716-.43-1.653-.7-2.692-.7-1.04 0-1.976.27-2.693.7zM8 2.856C7.105 2.313 5.978 2 4.77 2c-1.346 0-2.59.388-3.526 1.047A.593.593 0 001 3.533v9.886c0 .213.108.41.282.51a.505.505 0 00.55-.023c.741-.522 1.775-.859 2.937-.859 1.163 0 2.196.337 2.937.859.179.125.41.125.588 0 .741-.522 1.774-.859 2.937-.859 1.162 0 2.196.337 2.936.859a.505.505 0 00.55.024.589.589 0 00.283-.51V3.532a.593.593 0 00-.244-.486C13.819 2.388 12.576 2 11.23 2c-1.21 0-2.336.313-3.231.855z",
  fill: "#2D2D2D"
});
function SvgLibro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Libro.svg";
export { SvgLibro as ReactComponent };